import BaseComponent from "../../baseComponent.js";
import InternalEvent from "../../../core/constants/internalEvent.js";
import TabItem from "./tabItem.jsx";
import styles from "../../common/tab-list.scss";

export default class TabList extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.$tabList = $(this.refs.tabList);
    this.subscribe(InternalEvent.App.DOCUMENT_CLICKED, e => this.hideTabList(e));
  }

  componentWillUnmount() {
    this.unsubscribeAll();
  }

  changeDashboard(dashboardId) {
    let _this = this;
    this.hideTabList(null, function () {
      _this.props.onTabChange(dashboardId);
    });
    this.setState({currentWidgetIndex: 0});
  }

  showTabList() {
    if (this.$tabList.attr("data-active") != "true") {
      this.$tabList.attr("data-active", true).velocity("slideDown", 500);
    } else {
      this.hideTabList(null);
    }
  }

  hideTabList(target, callback) {
    if (target !== null) {
      if ($(target).parents("#tab-container").length || $(target).parents(".modal").length) return;
    }

    this.$tabList.attr("data-active", false).velocity("slideUp", {
      duration: 500, complete() {
        if (typeof callback === "function") callback();
      }
    });
  }

  render() {
    let tabs = [], dashboardListClasses = "dashboard-list row";
    for (let i = 0; i < this.props.tabs.length; i++) {
      tabs.push(<TabItem tab={this.props.tabs[i]} key={i}
                         onTabClick={this.changeDashboard}/>);
    }
    return (
      <div className="">
        <div className={styles.toggle} onClick={() => this.showTabList()} data-active="false">
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
        </div>
        <div className={styles.tabList} style={{width: "700px", marginLeft: "-350px"}} ref="tabList">
          <div className="row" style={{margin: 0}}>
            {tabs}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/profile/tab/tabList.jsx